<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jqZVgf/tc-custom/9781497689398.jpg?1734034012446" alt="This image is the cover for the book Deadly Deceits, Forbidden Bookshelf"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Deadly Deceits, Forbidden Bookshelf
      </h1>
      <p class="bookDescription body article font2">
        <b>A veteran of the Central Intelligence Agency unmasks its culture of lethal lies in this devastating exposé, now with a new foreword by David MacMichael.</b><br/><br/> Ralph W. McGehee was a patriot, dedicated to the American way of life and the international fight against Communism. Following his graduation with honors from Notre Dame, McGehee was recruited by the Central Intelligence Agency in 1952 and quickly became an able and enthusiastic cold warrior. Stationed in Southeast Asia in the mid-1960s, he worked to stem the Communist tide that was sweeping through the region, first in Thailand and later in Vietnam.<br/><br/> But despite his notable successes in reversing enemy influence among the local peasants and villagers, McGehee found himself increasingly alienated from a company culture built on deceit and wholesale manipulation of the truth. While his country was being pulled deeper and deeper into the Vietnam quagmire, McGehee awoke to a chilling reality: The CIA was not a gatherer of actual intelligence to be employed in a legitimate war against dangerous enemies, but a tool of the president’s foreign-policy staff designed solely to stifle the truth and fabricate “facts” that supported the agency’s often immoral agenda.<br/><br/> With courage and candor, Ralph McGehee illuminates the CIA’s dark catalog of misdeeds in his stunning, no-holds-barred memoir of a life in the service of deception. Startling, eye-opening, and infuriating, <i>Deadly Deceits </i>is an honest and unflinching insider’s look at a toxic government agency that the author cogently argues has no useful purpose and no moral right to exist.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ralph W.  McGehee, Mark Crispin Miller, David MacMichael
      </h2>
      
      <p class="authorDescription body article">Ralph W. McGehee&#160;was an all-American football player at the&#160;University of Notre Dame, where he helped the team to&#160;win three regional championships between 1946 and 1949. He graduated cum laude with a bachelor of science degree in business administration. McGehee was an officer of the&#160;Central Intelligence Agency&#160;from 1952 to 1977. Upon retirement he was awarded a career achievement medal, yet he went on to be highly critical of the organization. In addition to publishing an expos&eacute;, <I>Deadly Deceits: My 25 Years in the CIA</I>, for years he&#160;maintained the CIABASE digital archives, which revealed the agency&rsquo;s activities through the use of public domain resources.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7030611a